// ======================================================================
// File Name       : UserConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USER_SORT_TYPE = {
  userName: 0,
  loginId: 1,
  managementAuthoritySecernId: 2,
  groupNames: 3,
  lockState: 4,
};

export const USER_TYPE = {
  ALL: -1,
  ADMIN: 0,
  GUARDIAN: 1,
  STUDENT: 2,
};

export const USER_TYPE_LIST = [
  { name: '管理ユーザー', value: 0 },
  { name: '受講ユーザー', value: 2 },
];

export const COURSE_COMPLETITION_STATUS_ID = {
  INCOMPLETE: 0,
  DONE: 1,
};

export const COURSE_COMPLETITION_STATUS_NAME = {
  DONE: '完了',
  INCOMPLETE: '未完了',
};

// Step10.0.0 START
export const COURSE_COMPLETITION_STATUS_END_NAME = {
  DONE: '達成',
  INCOMPLETE: '未達成',
};
// Step10.0.0 END

export const ADMIN_ROLE = 'admin_role';

// #7096 START
export const DISPLAY_USER_TYPE = {
  L0_SUPER_USER: 0,
  SUPER_USER: 1,
  ADMIN: 2,
};
// #7096 END

// Step10.0.0 START
export const USER_TYPE_DISPLAY_LIST = [
  { name: '管理ユーザー', value: 0 },
  { name: '履歴閲覧ユーザー', value: 1 },
  { name: '受講ユーザー', value: 2 },
];
// Step10.0.0 END

// Step11.0.0 START
export const USER_CREATE_TYPE = {
  DEFINED_USER: 0,
  REPRESENTATIVE_USER: 1,
  DEFINED_AND_REPRESENTATIVE_USER: 2,
};

// Step11.0.0 END
